import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { type LalSegmentApi, lalSegmentStatus } from '@openx/types/segments.ts';
import { useTranslation } from 'react-i18next';

type DetailsHeaderAlertsProps = {
  lalSegment: LalSegmentApi;
};

export const DetailsHeaderAlerts = ({ lalSegment }: DetailsHeaderAlertsProps) => {
  const { t } = useTranslation();

  return (
    <>
      {lalSegment.status === lalSegmentStatus.EXPIRED && (
        <Alert severity="error">
          <Typography variant="body1">
            {t('LAL Segment is expired, please edit and save to generate a new Lookalike')}
          </Typography>
        </Alert>
      )}
    </>
  );
};
